import { useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { X, Phone, Mail } from 'lucide-react';

const QRCodePopup = ({ value, type, label, onClose }) => {
  const uri = type === 'phone' ? `tel:${value}` : `mailto:${value}`;
  const Icon = type === 'phone' ? Phone : Mail;

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center bg-black/40" onClick={onClose} data-testid="qr-popup-overlay">
      <div className="bg-white rounded-xl shadow-2xl p-6 max-w-xs w-full mx-4 relative" onClick={e => e.stopPropagation()} data-testid="qr-popup">
        <button onClick={onClose} className="absolute top-3 right-3 text-slate-400 hover:text-slate-600" data-testid="qr-close-btn">
          <X className="h-5 w-5" />
        </button>
        <div className="flex flex-col items-center gap-3">
          <div className="flex items-center gap-2 text-slate-700">
            <Icon className="h-4 w-4" />
            <span className="text-sm font-semibold">{type === 'phone' ? 'Call' : 'Email'}</span>
          </div>
          <p className="text-base font-mono text-slate-900" data-testid="qr-value">{value}</p>
          <div className="bg-white p-3 rounded-lg border border-slate-200">
            <QRCodeSVG value={uri} size={180} level="M" />
          </div>
          <p className="text-xs text-slate-400">Scan with your phone</p>
          {type === 'phone' ? (
            <span className="mt-1 text-sm text-blue-600 font-medium" data-testid="qr-direct-link">
              Use Call button on client page
            </span>
          ) : (
            <a
              href={uri}
              className="mt-1 text-sm text-blue-600 hover:text-blue-800 font-medium"
              data-testid="qr-direct-link"
            >
              Open email client
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export const ClickableContact = ({ value, type, className = '' }) => {
  const [showQR, setShowQR] = useState(false);
  if (!value) return null;

  return (
    <>
      <button
        onClick={(e) => { e.stopPropagation(); setShowQR(true); }}
        className={`text-slate-400 hover:text-blue-600 cursor-pointer transition-colors flex-shrink-0 ${className}`}
        data-testid={`qr-trigger-${type}`}
        title={`QR: ${value}`}
      >
        {type === 'phone' ? <Phone className="h-3 w-3" /> : <Mail className="h-3 w-3" />}
      </button>
      {showQR && <QRCodePopup value={value} type={type} onClose={() => setShowQR(false)} />}
    </>
  );
};

export default QRCodePopup;
